import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";

export default function ThankYou() {
  useEffect(() => {
    document.title = "¡Gracias! — Mirexilava";
    document.documentElement.lang = "es";
  }, []);

  return (
    <main className="thankyou">
      <div className="thankyou-inner">
        <div className="thankyou-icon">
          <CheckCircle2 size={40} strokeWidth={1.6} />
        </div>
        <h1>¡Gracias por escribirnos!</h1>
        <p>
          Recibimos tu mensaje correctamente. Nuestro equipo lo revisará y te vamos a responder por correo electrónico dentro de las próximas 48 horas hábiles. Mientras tanto, podés seguir explorando los proyectos publicados en la plataforma.
        </p>
        <p className="thankyou-sub">
          Si tu consulta es urgente, escribinos directamente a <a href="mailto:hola@mirexilava.com">hola@mirexilava.com</a>.
        </p>
        <Link to="/" className="btn btn-primary btn-lg" data-testid="back-home">
          <ArrowLeft size={16} /> Volver al inicio
        </Link>
      </div>
    </main>
  );
}
